import { Box, Chip, useTheme } from '@mui/material'
import EntityListTemplate from '../templates/EntityListTemplate'
import adjustColorContrast from '../utilities/adjustColorContrast'
import { buildCorrectedGradient } from '../utilities/paletteColors'

const PlotConfigurationPage = () => {
  const theme = useTheme()
  const columns = [
    {
      field: 'plotName',
      headerName: 'Name',
      flex: 2,
      minWidth: 160,
      sortable: true,
    },
    {
      field: 'analysisName',
      headerName: 'Analysis',
      flex: 2,
      minWidth: 160,
      sortable: false,
    },
    {
      field: 'color',
      headerName: 'Color',
      width: 80,
      sortable: false,
      renderCell: ({ row }) => {
        const isGradient = row.isMultiline && row.type === 'time-series'
        const gradient = isGradient
          ? buildCorrectedGradient(row.colorPalette, theme)
          : null
        const background =
          gradient ?? (row.color ? adjustColorContrast(row.color, theme) : null)
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            {background ? (
              <Box
                sx={{
                  width: 48,
                  height: 16,
                  borderRadius: 0.5,
                  background,
                }}
              />
            ) : null}
          </Box>
        )
      },
    },
    {
      field: 'config',
      headerName: 'Parameters',
      width: 110,
      sortable: false,
      renderCell: ({ row }) => row.config?.parameters?.length ?? 0,
    },
    {
      field: 'unit',
      headerName: 'Unit',
      width: 100,
      sortable: false,
    },
    {
      field: 'active',
      headerName: 'Active',
      width: 90,
      sortable: false,
      renderCell: ({ row }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <Chip
            label={row.active ? 'Active' : 'Inactive'}
            color={row.active ? 'success' : 'default'}
            size="small"
          />
        </Box>
      ),
    },
  ]

  return (
    <EntityListTemplate
      entityName="plots"
      columns={columns}
      title="Plot Configurations"
      defaultSort={[{ field: 'createdAt', sort: 'desc' }]}
    />
  )
}

export default PlotConfigurationPage
